import React, { Component } from "react";
import classnames from "classnames";
import { observer } from "mobx-react";

import { Measure } from "@formant/ui/component/common/Measure";

import { operateStore } from "../../stores";
import * as styles from "./FitFill.scss";
import { WindowResizer } from "./WindowResizer";

export interface IFitFillProps {
    className?: string;
    fill?: boolean;
    children?: React.ReactNode;
}

@observer
export class FitFill extends Component<IFitFillProps> {
    private canUpdateContainerDimensions: boolean = true;

    public render() {
        const { children, className, fill } = this.props;
        const { onDoubleClick } = this;

        return (
            <>
                <Measure
                    className={classnames(
                        styles["fit-fill"],
                        fill ? styles.fill : styles.fit,
                        className,
                    )}
                    onDoubleClick={onDoubleClick}
                    onMeasureResize={this.onResize}
                >
                    {children}
                </Measure>
                <WindowResizer onResize={this.onResizeWindow} />
            </>
        );
    }

    private onDoubleClick = () => {
        const { fill } = this.props;
        operateStore.fill = !fill;
    };

    private onResize = (width: number, height: number) => {
        if (!this.canUpdateContainerDimensions) {
            return;
        }
        operateStore.containerDimensions = { x: width, y: height };
        this.canUpdateContainerDimensions = false; // wait until next window resize
    };

    private onResizeWindow = () => {
        this.canUpdateContainerDimensions = true;
        operateStore.fill = undefined;
    };
}
